import { api } from "..";
import { QueryProps } from "@/types/Api";
import { NewUser } from "@/types/ApiResponses/User";

export const getUser = async (props: QueryProps): Promise<NewUser> => {
  const res = await api.client.get("/account", {
    signal: props.signal,
  });
  return res.data;
};
